<div class="dialog">
    <div class="dialog_logo"></div>
    <div class="dialog_text"  *ngIf="userInfo.freemiumAvail">
        Upgrade to premium now to enjoy shipyard without limitations!
    </div>
    <div class="dialog_text" *ngIf="!userInfo.freemiumAvail">
        <div><b>No Credits left.</b></div>  Upgrade or buy new credits to continue creating shipments.
    </div>
    <app-button (click)="upgrade()">
        Upgrade
    </app-button>
</div>